import { render, staticRenderFns } from "./EmailTemplateEdit.vue?vue&type=template&id=07bd60f8&scoped=true&"
import script from "./EmailTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateEdit.vue?vue&type=style&index=0&id=07bd60f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bd60f8",
  null
  
)

export default component.exports